<template>
  <van-popup
    :value="value"
    position="bottom"
    round
    :style="{ height: '88%' }"
    class="merge-pay-popup"
    @input="$emit('input', $event)"
  >
    <div class="merge-pay-popup__title">填写打款信息</div>

    <van-cell-group inset>
      <van-field label="门店" :value="summary.storename" readonly />
      <van-field label="合计金额" :value="summary.totalText" readonly />
      <van-field
        readonly
        clickable
        required
        label="支付日期"
        :value="form.paydate"
        placeholder="请选择"
        @click="showCal = true"
      />
      <van-field readonly clickable
            required label="打款名称"
            :value="form.payaccountname" placeholder="请选择"
            @click="showac = true"/>
      <van-field readonly required label="打款账号"
                   :value="form.payaccountno" placeholder="请选择"/>

      <div class="merge-pay-voucher-wrap">
        <div class="merge-pay-voucher-wrap__label">打款凭证</div>
        <p class="merge-pay-voucher-cell__tip">
          点击上传或<strong>Ctrl+V</strong>粘贴截图；识别<strong>打款账号</strong>与<strong>打款公司</strong>并填入下方（可改）
        </p>
        <van-uploader
          v-model="voucherFileList"
          :max-count="1"
          accept="image/*"
          :after-read="onVoucherAfterRead"
          @delete="onVoucherDelete"
        />
      </div>
      <van-field
        v-model="form.payaccount"
        required
        readonly
        label="ORC账号"
        placeholder="可上传凭证自动识别，或手填"
      />
      <van-field
        v-model="form.orcpayaccountname"
        required
        readonly
        label="ORC公司"
        placeholder="付款户名/公司名"
      />
    </van-cell-group>

    <div v-if="lineItems.length" class="merge-pay-popup__lines">
      <div class="merge-pay-popup__lines-scroll">
        <div
          v-for="(it, idx) in lineItems"
          :key="it.id != null ? `p-${it.id}` : `i-${idx}`"
          class="merge-pay-line"
        >
          <div v-if="it.billNo" class="merge-pay-line__bill">单据 {{ it.billNo }}</div>
          <div class="merge-pay-line__main">
            <span class="merge-pay-line__txt">{{ it.paycontont || '—' }}</span>
            <span class="merge-pay-line__amt">¥{{ formatAmt(it.amount) }}</span>
          </div>
          <div class="merge-pay-line__rece">
            <div class="merge-pay-line__rece-row">
              <span class="merge-pay-line__rece-lbl">收款姓名</span>
              <span class="merge-pay-line__rece-val">{{ displayField(it.receName) }}</span>
            </div>
            <div class="merge-pay-line__rece-row">
              <span class="merge-pay-line__rece-lbl">收款账号</span>
              <span class="merge-pay-line__rece-val merge-pay-line__rece-val--account">{{
                displayField(it.receAccount)
              }}</span>
            </div>
            <div class="merge-pay-line__rece-row">
              <span class="merge-pay-line__rece-lbl">开户行</span>
              <span class="merge-pay-line__rece-val">{{ displayField(it.receBank) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="merge-pay-popup__actions">
      <van-button block plain type="default" @click="close">取消</van-button>
      <van-button block type="primary" :loading="submitting" @click="handleConfirm">
        确认打款
      </van-button>
    </div>
    <van-calendar
      v-model="showCal"
      type="single"
      :min-date="minDate"
      :max-date="maxDate"
      @confirm="onDateConfirm"
    />
      <van-popup
          :value="showac"
          position="bottom"
          round
          :style="{ height: '50%' }"
          class="merge-pay-popup"
      >
          <van-picker
              show-toolbar
              title="选择账户"
              value-key="accountname"
              :default-index="defIdx"
              :columns="storeAccounts"
              @cancel="showac = false"
              @confirm="onStoreAccountConfirm"
          />
      </van-popup>
  </van-popup>
</template>

<script>
import { Toast } from 'vant'
import { Dialog } from 'vant'
import {recognizePaymentVoucher} from '../util/payment'

export default {
    name: 'MergePaymentDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        summary: {
            type: Object,
            default: () => ({
                storeid: '',
                storename:"",
                lineCount: 0,
                totalText: 0
            })
        },
        submitting: {
            type: Boolean,
            default: false
        },
        /** 已选 payout 明细：id、paycontont、amount、billNo、receName/receAccount/receBank（对应 detal1~3） */
        lineItems: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            orcData:null,
            defIdx:-1,
            storeAccounts:[],
            showac:false,
            voucherFileList: [],
            showCal: false,
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2099, 11, 31),
            form: {
                orderno:"",
                paydate: this.$moment().format("YYYY-MM-DD"),
                payaccount: '',
                payaccountname: '',
                payvoucher: '',
                createtor: '',
                createtorname: '',
                orcpayaccountname:"",
                payaccountno:"",
            }
        }
    },
    watch: {
        async value(val) {
            if (val) {
                await this.getStoreAccountByStructs();

                let orderNo=this.getOrderNo();
                this.voucherFileList = []
                this.form = {
                    orderno:"",
                    paydate: this.$moment().format("YYYY-MM-DD"),
                    payaccount: '',
                    payaccountname: '',
                    payvoucher: '',
                    createtor: '',
                    createtorname: '',
                    orcpayaccountname:"",
                }


                orderNo.then(val=>{
                    this.form.orderno=val;
                });
                //获取默认银行账户
                this.findDefAccountName();

                this.$nextTick(() => {
                    window.addEventListener('paste', this.onWindowPaste)
                })
            } else {
                window.removeEventListener('paste', this.onWindowPaste)
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener('paste', this.onWindowPaste)
    },
    methods: {
        async getOrderNo(){
            let sysbillid="";
            await this.$post("product/getSysBillId").then(res=>{
                if(res.sucess){
                    sysbillid=res.object;
                }
            });
            return sysbillid;
        },
        findDefAccountName(){
            let i=0;
            for(let val of this.storeAccounts){
                if(val.storeid==this.summary.storeid && val.def==1){
                    this.form.payaccountname=val.accountname;
                    this.form.payaccountno=val.accountno;
                    this.defIdx=i;
                    break;
                }
                i++;
            }
        },
        async getStoreAccountByStructs(){
            await this.$post("/store/getStoreAccountByStructs",{storeid:localStorage.getItem("storeid")}).then(res=>{
                this.storeAccounts=res.object;
            });
        },
        onStoreAccountConfirm(value){
            this.form.payaccountname=value.accountname;
            this.form.payaccountno=value.accountno;
            this.showac=false;
        },
        close() {
            this.$emit('input', false);
        },
        onDateConfirm(date) {
            this.showCal = false
            return this.$moment(date).format("YYYY-MM-DD");
        },
        formatAmt(v) {
            if (v === null || v === undefined || v === '') return '—'
            const n = Number(v)
            return Number.isFinite(n) ? n.toFixed(2) : String(v)
        },
        displayField(v) {
            if (v === null || v === undefined || String(v).trim() === '') return '—'
            return String(v)
        },
        onWindowPaste(e) {
            if (!this.value) return
            const cd = e.clipboardData
            if (!cd || !cd.items) return
            for (let i = 0; i < cd.items.length; i++) {
                const it = cd.items[i]
                if (it.kind === 'file' && it.type.indexOf('image') === 0) {
                    const f = it.getAsFile()
                    if (f) {
                        e.preventDefault()
                        const item = {file: f, status: 'uploading'}
                        //this.voucherFileList = [item]
                        //console.log(this.voucherFileList);
                        this.processVoucherItem(item)
                        this.uploadFile(f);
                        break
                    }
                }
            }
        },
        async onVoucherAfterRead(file) {
            const item = Array.isArray(file) ? file[file.length - 1] : file
            await this.processVoucherItem(item)
            await this.uploadFile(file);
            /*this.$upload("file/filePathUpload?path=finance",formData).then(res=>{

            });*/
        },
        async uploadFile(file){
            this.voucherFileList=[];
            let formData=new FormData();
            formData.append("file",file);
            this.$upload("file/filePathUpload?path=finance",formData).then(res=>{
                if(res.sucess){
                    let obj=new Object();
                    obj.deletable=true;
                    obj.url=this.baseImageUrl+res.object;
                    this.voucherFileList.push(obj);
                    this.form.payvoucher=res.object;
                }
            })
        },
        async processVoucherItem(item) {
            if (!item.file) {
                item.status = 'failed'
                Toast.fail('无法读取图片文件')
                return
            }
            item.status = 'uploading'
            try {
                const res = await recognizePaymentVoucher(item.file)
                this.orcData=res.data;
                const d = res.data || {}
                if (d.payaccount) this.form.payaccount = String(d.payaccount).trim()
                if (d.payaccountname) this.form.orcpayaccountname = String(d.payaccountname).trim()
                if (d.payvoucherUrl != null && d.payvoucherUrl !== '') {
                    this.form.payvoucher = String(d.payvoucherUrl)
                } else if (d.payvoucher != null && d.payvoucher !== '') {
                    this.form.payvoucher = String(d.payvoucher)
                }
                console.log(d);
                item.status = 'done'
                Toast.success('已识别打款账号与打款公司，请核对')
            } catch (e) {
                item.status = 'failed'
                Toast.fail(
                    (e.response && e.response.data && e.response.data.message) || '凭证识别失败'
                )
            }
        },
        onVoucherDelete() {
            this.form.payvoucher = ''
            this.voucherFileList=[];
        },
        async handleConfirm() {
            if(this.voucherFileList.length<1){
                Toast('请上传打款凭证')
                return;
            }

            if (!this.form.paydate) {
                Toast('请选择支付日期')
                return
            }
            if (!String(this.form.payaccount || '').trim()) {
                Toast('请填写打款账号')
                return
            }
            if (!String(this.form.payaccountname || '').trim()) {
                Toast('请填写打款公司')
                return
            }

            let messages=[];
            /*if(this.form.payaccountname!=this.form.orcpayaccountname){
                messages.push(`打款账号是：凭证为「${this.form.payaccountname}」，识别出来的打款账号是「${this.form.orcpayaccountname}」`)
            }*/

            //console.log(this.orcData);
            const { warn, lines } = this.buildPayeeMismatchWarning(
                this.form.payaccountno,
                this.orcData.payaccount,
                this.orcData.recvaccountname,
                this.orcData.recvaccount,
                this.lineItems[0].receName,
                this.lineItems[0].receAccount,
                this.orcData.amount,
                this.summary.totalText
            )


            if(lines.length>0){
                messages.push(lines);
            }
            let isave=true;
            if(messages.length>0){
                await Dialog.confirm({
                    title: '凭证与明细不一致',
                    message: `${messages.join('\n')}\n\n仍可继续提交打款，请确认是否继续？`,
                    confirmButtonText: '仍要提交',
                    cancelButtonText: '返回修改',
                }).catch(()=>{
                    isave=false;
                })
            }

            if(isave==false){
                return;
            }

            let payMentMout={};
            payMentMout.storeid=this.summary.storeid;
            //payMentMout.orderno=this.summary.sysbillid;
            payMentMout.totalamount=this.summary.totalText;
            payMentMout.paydate=this.form.paydate;
            payMentMout.createtor=localStorage.getItem("staffid");
            payMentMout.createtorname=localStorage.getItem("staffname");
            payMentMout.payvoucher=this.form.payvoucher;
            payMentMout.payaccount=this.form.payaccount;
            payMentMout.payaccountname=this.form.payaccountname;
            payMentMout.payaccountno=this.form.payaccountno;
            let payMentOutDetals=new Array();
            for(let val of this.lineItems){
                let payMentOutDetal={};
                payMentOutDetal.storeid=this.summary.storeid;
                //payMentOutDetal.orderno=payMentMout.orderno;
                payMentOutDetal.pid=val.id;
                payMentOutDetal.paycontont=val.paycontont;
                payMentOutDetal.amount=val.amount;
                payMentOutDetal.receaccount=val.receAccount;
                payMentOutDetal.receaccountname=val.receName;
                payMentOutDetal.receaccountback=val.receBank;
                payMentOutDetals.push(payMentOutDetal);
            }

            let payMentMoutVo={};
            payMentMoutVo.payMentMout=payMentMout;
            payMentMoutVo.payMentOutDetals=payMentOutDetals;
            this.$postw("/payout/savePayMentMout",payMentMoutVo).then(res=>{
                if(res.sucess){
                    this.$message({message: "打款成功", type: 'success'});
                    this.close();
                    if(this.$parent.$route.name=="headpayount"){
                        this.$parent.fetchList();
                    }
                    else{
                        this.goBack();
                    }
                }
            });

            //this.$emit('confirm', {...this.form})
        },
        goBack() {
            this.$router.push({name: 'headpayount'})
        },
        buildPayeeMismatchWarning(
            payno,
            orcpayno,
            ocrName,
            ocrAccount,
            manualName,
            manualAccount,
            ocrAmount,
            manualTotalCents) {
            const oN = String(ocrName || '').trim()
            const oA = String(ocrAccount || '').trim()
            const mN = String(manualName || '').trim()
            const mA = String(manualAccount || '').trim()
            const oAmt = String(ocrAmount == null ? '' : ocrAmount).trim()
            const pn=String(payno || '').trim();
            const opn=String(orcpayno || '').trim();
            const hasRecvOcr = Boolean(oN || oA)
            const hasPayOcr=Boolean(pn|| opn);
            if (!hasRecvOcr && !oAmt) return { warn: false, lines: [] }

            const lines = []
            //console.log(oAmt,manualTotalCents);
            if (oAmt && manualTotalCents != null) {
                let oCents = this.parseMoneyStringToCents(oAmt);
                //oCents=oCents.toFixed(2);
                //console.log(typeof oCents)
                //console.log(oCents,manualTotalCents)
                if (oCents !== null && oAmt != manualTotalCents) {
                    const manualYuan = (manualTotalCents / 1).toFixed(2)
                    lines.push(`打款金额：凭证为「${oAmt}」，明细合计为「${manualYuan}」`)
                }
            }

            if (hasRecvOcr) {
                if (mN && oN && !this.recvNamesMatch(oN, mN)) {
                    lines.push(`收款姓名：凭证为「${oN}」，明细为「${mN}」`)
                }
                if (mA && oA && !this.recvAccountsMatch(oA, mA)) {
                    lines.push(`收款账号：凭证为「${oA}」，明细为「${mA}」`)
                }
            }

            if(hasPayOcr){
                if (!this.recvAccountsMatch(pn, opn)) {
                    lines.push(`打款账户：「${pn}」，识别的账户：「${opn}」`)
                }
            }

            return { warn: lines.length > 0, lines }
        },
        /**
         * 金额字符串（可含千分位逗号）→ 分（整数），无法解析返回 null
         */
        parseMoneyStringToCents(s) {
            if (s == null || s === '') return null
            const t = String(s).trim().replace(/,/g, '').replace(/，/g, '')
            if (t === '') return null
            const n = Number(t)
            if (!Number.isFinite(n)) return null
            return Math.round(n * 100)
        },
        /**
         * 凭证识别收款姓名 vs 明细（去空白后全等）
         */
        recvNamesMatch(ocrName, manualName) {
            const o = String(ocrName || '').trim()
            const n = String(manualName || '').trim()
            if (!o || !n) return true
            return o === n
        },
        /**
         * 凭证识别收款账号 vs 明细收款账号
         * - 识别结果为全数字：两侧去空白后整串相等
         * - 识别结果含非数字符号（如 *）：两侧只比较数字序列
         */
        recvAccountsMatch(ocrAccount, manualAccount) {
            const o = String(ocrAccount || '').trim()
            const m = String(manualAccount || '').trim()
            if (!o || !m) return true
            const oNoSpace = o.replace(/\s/g, '')
            const mNoSpace = m.replace(/\s/g, '')

            return this.isBankCardEqual(ocrAccount,manualAccount);
        },
        /**
         * 判断两个银行卡号是否视为相同
         * - 两个完整卡号：完全一致才通过
         * - 完整卡号 + 脱敏卡号：完整卡号的前缀与脱敏前缀一致，且后4位一致（前缀可为任意长度）
         * - 两个脱敏卡号：前缀 & 后4位一致即通过（星号数量不限）
         */
        isBankCardEqual(a, b) {
            const strA = String(a).trim();
            const strB = String(b).trim();

            const isFull = (s) => /^\d+$/.test(s);
            // 脱敏卡号格式：至少1位数字 + 至少1个* + 恰好4位数字结尾
            const isMask = (s) => /^\d+\*+\d{4}$/.test(s);

            // 1. 两个都是完整卡号
            if (isFull(strA) && isFull(strB)) {
                return strA === strB;
            }

            // 2. 两个都是脱敏卡号
            if (isMask(strA) && isMask(strB)) {
                const getParts = (s) => s.match(/^(\d+)\*+(\d{4})$/).slice(1);
                const [preA, sufA] = getParts(strA);
                const [preB, sufB] = getParts(strB);
                return preA === preB && sufA === sufB;
            }

            // 3. 一个完整，一个脱敏
            const full = isFull(strA) ? strA : isFull(strB) ? strB : null;
            const mask = isFull(strA) ? strB : isFull(strB) ? strA : null;
            if (!full || !mask || !isMask(mask)) return false;

            const match = mask.match(/^(\d+)\*+(\d{4})$/);
            const prefix = match[1];
            const suffix = match[2];

            return full.startsWith(prefix) && full.endsWith(suffix);
        },
        /**
         * 去掉空白后是否纯数字账号（用于决定全串比还是只比数字）
         */
        isAllDigitAccountString(s) {
            const t = String(s || '').replace(/\s/g, '')
            console.log("isAllDigitAccountString//////"+t);
            return t.length > 0 && /^\d+$/.test(t)
        },
        /**
         * 账号比对用：仅保留数字
         */
        accountDigitsOnly(s) {
            if (s == null || s === '') return ''
            return String(s).replace(/\D/g, '')
        }
    }
}
</script>

<style scoped>
.merge-pay-popup__title {
  padding: 16px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
}
.merge-pay-voucher-wrap {
  margin: 0 16px 12px;
  padding: 12px 0;
}
.merge-pay-voucher-wrap__label {
  font-size: 14px;
  color: #646566;
  margin-bottom: 8px;
}
.merge-pay-voucher-cell__tip {
  margin: 0 0 10px;
  font-size: 12px;
  color: #969799;
  line-height: 1.5;
}
.merge-pay-popup__lines {
  margin: 0 12px 12px;
  padding: 10px 12px;
  background: #f7f8fa;
  border-radius: 8px;
  max-height: 42vh;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.merge-pay-popup__lines-title {
  font-size: 13px;
  font-weight: 600;
  color: #646566;
  margin-bottom: 8px;
  flex-shrink: 0;
}
.merge-pay-popup__lines-scroll {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.merge-pay-line {
  padding: 8px 0;
  border-bottom: 1px solid #ebedf0;
  font-size: 13px;
}
.merge-pay-line:last-child {
  border-bottom: none;
}
.merge-pay-line__bill {
  font-size: 12px;
  color: #969799;
  margin-bottom: 4px;
}
.merge-pay-line__main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
}
.merge-pay-line__txt {
  flex: 1;
  min-width: 0;
  color: #323233;
  line-height: 1.45;
  word-break: break-word;
}
.merge-pay-line__amt {
  flex-shrink: 0;
  font-weight: 600;
  color: #ee0a24;
}
.merge-pay-line__rece {
  margin-top: 8px;
  padding: 8px 8px 6px;
  background: #fff;
  border-radius: 6px;
  font-size: 12px;
}
.merge-pay-line__rece-row {
  display: flex;
  gap: 8px;
  line-height: 1.5;
  margin-bottom: 4px;
}
.merge-pay-line__rece-row:last-child {
  margin-bottom: 0;
}
.merge-pay-line__rece-lbl {
  flex-shrink: 0;
  width: 4.5em;
  color: #969799;
}
.merge-pay-line__rece-val {
  flex: 1;
  min-width: 0;
  color: #323233;
  word-break: break-word;
}
.merge-pay-line__rece-val--account {
  word-break: break-all;
  overflow-wrap: anywhere;
}
.merge-pay-popup__actions {
  display: flex;
  gap: 10px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom, 0px));
}
</style>



// WEBPACK FOOTER //
// src/components/MergePaymentDialog.vue